<template>
    <div id='ItemList' class='row'>
        <div class='col-12'>
            <div class='row'>
                <div class='col-12 ListOfItems'>
                    <List
                        :initialReportState='report'
                        :allowExport='true'
                        listType='Item'
                        @manage-box='manageBox'
                        @print-label='printLabel'
                        @print-loa='printLoa'
                        @edit-item='editItem'
                        @item-card='itemCard'
                        @open-receipt='openReceipt'
                        @delete='deleteItem'
                    >
                        <template v-slot:buttons>
                            <Button 
                                btnAction='CreateNewItem'
                                btnTarget='createnew-item'
                                CTA='Create New Item'
                                type='primary'
                                btnClass='BtnCreate'
                                @createnew-item = 'createnewItem'
                            />
                        </template>
                    </List>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TextBox from '../../../core/form/TextBox.vue';
    import Button from '../../../core/form/Button.vue';
    import Select from '../../../core/form/Select.vue';
    import DisplayIcon from '../../../icons/DisplayIcon';
    import List from '../../../core/list/List';
    
    export default{
        name: 'ItemList',
        components: {
            TextBox,
            Button,
            DisplayIcon,
            Select,
            List
        },
        data(){
            return{
                boxOptions: []
            }
        },
        computed: {
            report() {
                var report = this.$store.getters['BuyTracker/ItemCreate/itemReportList'];
                return report ? report : this.$store.getters['BuyTracker/ItemCreate/itemReportList'];
            }
        },
        created(){
            this.getBoxOptions();
        },
        methods:{
            //exportItems(){
            //    console.log('export items'); //TODO: Export items
            //},
            addtoBox(value){
                console.log('Adding to Box - '+ value); //TODO - Add To Box
            },
            getBoxOptions() {
                this.$api.get('/api/faker', {}).then(response => {
                    this.boxOptions = [
                        {value: 1, label: 'box 1'},
                        {value: 2, label: 'box 2'},
                        {value: 1, label: 'box 3'},
                        {value: 2, label: 'box 4'}
                    ]
                });
            },
            manageBox(){
                console.log('manageBox reached!!')
            },
            printLabel(){
                console.log('Print-label reached!!')
            },
            printLoa(){
                console.log('printLoa reached!!')
            },
            editItem(payload){
                console.log('editItem reached!!')
                this.$store.dispatch('ItemCard/fetchItem', {sku: payload.sku, store: 'ItemCard'})
                    .then(() => {
                        console.log('returned?');
                        //this.saveProduct()
                        })
                    .catch((error) => {
                    //commit('setFetchError', error)
                        console.log('error returning promise: ' + error)
                    });
            },
            itemCard(payload){
                console.log('itemCard reached!!  '+ payload.sku)

                this.$store.dispatch('ItemCard/fetchItem', {sku: payload.sku, store: 'ItemCard'})
                    .then(() => {
                        console.log('returned?');
                        //this.saveProduct()
                        })
                    .catch((error) => {
                    //commit('setFetchError', error)
                        console.log('error returning promise: ' + error)
                    });
            },
            openReceipt(){
                console.log('openReceipt reached!!')
            },
            deleteItem(){
                console.log('deleteItem reached!!')
            },
            saveProduct(){
                console.log("save product called????")
                let tempProduct = {};
                for(const item in this.currentProduct){
                    console.log('item: '+`${item} -> ${this.currentProduct[item]}`);
                    console.log('item alone: '+ item);
                    let itemName = item;
                    if(itemName != 'createdCollection'){
                        Object.assign(tempProduct, {[itemName]:  this.currentProduct[item]});
                    }
                    //this.$store.commit('ItemInfo/addToProduct', {itemName: item, value: this.currentProduct[item]})
                    
                };
                //console.log('tempProduct: ' + Object.entries(tempProduct));
                this.$store.dispatch('ProductCollection/set', {field: 'selectedProduct', value: tempProduct})
                let tempProductCollection = this.productCollection;
                console.log('pushing: '+ tempProduct + ' into - '+ this.productCollection)
                if(tempProductCollection.findIndex(x => x.productSku == tempProduct.productSku) == -1){
                    tempProductCollection.push(tempProduct);
                    this.$store.dispatch('ProductCollection/set', {field: 'createdCollection', value: tempProductCollection})
                }
            },
            createnewItem(){
                console.log('create new item');
                this.$router.push('/buy-tracker/item-create')

            },
            exportItems () {
                console.log('exporting - ');
                // naive encoding to csv format
                const content = [ this.columns.map(col => wrapCsvValue(col.label)) ].concat(
                    this.data.map(row => this.columns.map(col => wrapCsvValue(
                    typeof col.field === 'function'
                        ? col.field(row)
                        : row[col.field === void 0 ? col.name : col.field],
                    col.format
                    )).join(','))
                ).join('\r\n')

                const status = exportFile(
                    'table-export.csv',
                    content,
                    'text/csv'
                )

                if (status !== true) {
                    this.$q.notify({
                    message: 'Browser denied file download...',
                    color: 'negative',
                    icon: 'warning'
                    })
                }
            }
        }
    }
</script>